module.exports = __webpack_public_path__ + "static/media/2018_0716_18502800-03.4ee0213e.jpg";